<template>
    <div style="height:100%;">
        <p style="display: flex;
         font-size: 30px;
         flex-direction: row;
         height: 45px;
         color: rgb(221,114,2);
         border-bottom: solid 0.06rem rgb(193,193,193);">
         Enrichment analysis using conventional analysis method
        </p> 
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 18px;text-align: left;line-height: 30px;">
                In this section, we show the results of <strong style="font-size:22px;">GO enrichment</strong> analysis and <strong style="font-size:22px;">KEGG pathway enrichment</strong> analysis using genes collected from the database. 
                We used the most commonly used enrichment analysis method based on Hypergeometric distribution, giving each gene the same weight.     
               </div>
        </el-card>    
        <el-tabs style="height:100%;margin-top: 50px;" type="border-card" v-model="activePane" @tab-click="handleClick">
        <!-- Data -->
            <el-tab-pane label="GO enrichment" name="go">
                Select domains: 
                <el-select @change="selectChanged" v-model="activeType" placeholder="Choose type" >
                    <el-option
                        v-for="item in typeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <br/><br/>
                <BubblechartVue :plotData="plotData" :name="yaxis" v-if="activePane=='go'"></BubblechartVue>
                <el-table ref="GOtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="KEGG pathway enrichment" name="kegg">
                <br/><br/>
                <BubblechartVue :plotData="KEGGData" :name="yaxis" v-if="activePane=='kegg'"></BubblechartVue>
                <el-table ref="KEGGtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
           
        </el-tabs>
    </div>
</template>

<script>
import BubblechartVue from '../../../chart/Bubblechart.vue';
import{Loading}from'element-ui';
export default{
    data(){    
        return{
            tableData:[],
            yaxis:'GO term',
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:1,
            // 默认每页显示的条数（可修改）
            pageSize:10,
            desc:null,
            sortby:null,
            activePane:"go",
            activeType:'Biological Process',
            tableFields: [
                { key: "term_id", label: "Term ID", sortable: true,width:'105px'},
                { key: "description", label: "Description", sortable: true,width:'150px'},
                { key: "gene_ratio", label: "Gene ratio", sortable: true,width:120},
                { key: "bg_ratio", label: "Bg ratio", sortable: true,width:100},
                { key: "pvalue", label: "pvalue", sortable: true,width:110,formatter:this.rounding},
                { key: "p_adjust", label: "p.adjust", sortable: true ,formatter:this.rounding,width:110},
                { key: "qvalue", label: "qvalue",sortable: true ,width:100,formatter:this.rounding},
                { key: "gene_id", label: "Gene id", sortable: true,minWidth:300},
                { key: "count", label: "Count", sortable: true,width:110},
                // { key: "type", label: "Category", sortable: true,width:120},
            ],
            typeOption:[{
                value: 'Biological Process',
                label: 'Biological Process'
                },{
                value: 'Cellular Component',
                label: 'Cellular Component'
                },{
                value: 'Molecular Function',
                label: 'Molecular Function'
                }],
            plotData: null,
            BPData:[[0.0992537313432836,'modulation of chemical synaptic transmission',44.8275042340875,133,'GO:0050804','439/18723',3.74765247603324E-49,7.56148095786977E-46,'133/1340'],
                [0.0992537313432836,'regulation of trans-synaptic signaling',44.8275042340875,133,'GO:0099177','440/18723',5.01985109013017E-49,7.56148095786977E-46,'133/1340'],
                [0.0902985074626866,'signal release',33.4716776445642,121,'GO:0023061','463/18723',1.70847521533086E-37,1.71566879518489E-34,'121/1340'],
                [0.0873134328358209,'response to xenobiotic stimulus',30.9490563501488,117,'GO:0009410','462/18723',7.58872323130719E-35,5.71550681263189E-32,'117/1340'],
                [0.0738805970149254,'response to lipopolysaccharide',30.8889479619271,99,'GO:0032496','343/18723',1.08939935842437E-34,6.56391781854852E-32,'99/1340'],
                [0.0626865671641791,'learning or memory',30.5069659074358,84,'GO:0007611','255/18723',3.1502891374713E-34,1.58177675639349E-31,'84/1340'],
                [0.0746268656716418,'response to molecule of bacterial origin',29.4993259845487,100,'GO:0002237','363/18723',3.74056433096998E-33,1.60984888950919E-30,'100/1340'],
                [0.0664179104477612,'cognition',29.1664992188894,89,'GO:0050890','296/18723',9.19932243026251E-33,3.46427115729096E-30,'89/1340'],
                [0.0664179104477612,'rhythmic process',28.9691061240359,89,'GO:0048511','298/18723',1.63042737351083E-32,5.45764110290995E-30,'89/1340'],
                [0.0649253731343284,'positive regulation of secretion',26.0983153667499,87,'GO:0051047','310/18723',1.34539467987976E-29,4.05317849875356E-27,'87/1340'],
                ],
            MFData:[[0.0836417468541821,'signaling receptor activator activity',24.530547512529,113,'GO:0030546','495/18368',2.76240955821464E-28,2.25354463959615E-25,'113/1351'],
                [0.0814211695040711,'receptor ligand activity',23.6822824257112,110,'GO:0048018','487/18368',3.89567887686246E-27,1.58902691029916E-24,'110/1351'],
                [0.0429311621021466,'cytokine activity',13.4205470523721,58,'GO:0005125','235/18368',1.06760299366731E-16,2.90313094769181E-14,'58/1351'],
                [0.0281273131014064,'neurotransmitter receptor activity',13.2710600564339,38,'GO:0030594','111/18368',2.00833203362258E-16,4.09594033173027E-14,'38/1351'],
                [0.0444115470022206,'cytokine receptor binding',11.8314618675832,60,'GO:0005126','271/18368',6.90786302355141E-15,1.12707238805312E-12,'60/1351'],
                [0.0466321243523316,'G protein-coupled receptor binding',11.8070574779667,63,'GO:0001664','295/18368',8.76858170368251E-15,1.19221944216736E-12,'63/1351'],
                [0.0259067357512953,'hormone activity',9.74040800530118,35,'GO:0005179','122/18368',1.19268460996754E-12,1.38997078605239E-10,'35/1351'],
                [0.0296076980014804,'growth factor activity',9.09540707679596,40,'GO:0008083','162/18368',6.01891888849088E-12,6.13771334023741E-10,'40/1351'],
                [0.0436713545521836,'peptide binding',8.25576937135847,59,'GO:0042277','321/18368',4.68067749472372E-11,4.24271936656244E-09,'59/1351'],
                [0.0111028867505551,'glutamate receptor activity',8.13204588884736,15,'GO:0008066','27/18368',6.91496031013419E-11,5.64115183195158E-09,'15/1351'],
                ],
            CCData:[[0.0732600732600733,'synaptic membrane',28.2657276224042,100,'GO:0097060','384/19550',8.69136097954854E-32,3.76015722378363E-29,'100/1365'],
                [0.0586080586080586,'distal axon',23.777332019313,80,'GO:0150034','294/19550',5.35196650388309E-27,1.15771485952419E-24,'80/1365'],
                [0.0564102564102564,'postsynaptic membrane',23.6376645578896,77,'GO:0045211','277/19550',1.10731735621277E-26,1.59686818738053E-24,'77/1365'],
                [0.0571428571428571,'glutamatergic synapse',18.5330594281317,78,'GO:0098978','338/19550',1.8785206500973E-21,2.03176838734208E-19,'78/1365'],
                [0.0534798534798535,'vesicle lumen',16.4555805774526,73,'GO:0031983','327/19550',2.80675714708952E-19,2.4285835525343E-17,'73/1365'],
                [0.052014652014652,'secretory granule lumen',15.7268129472231,71,'GO:0034774','322/19550',1.80365601095533E-18,1.30053091316252E-16,'71/1365'],
                [0.052014652014652,'cytoplasmic vesicle lumen',15.5605129242951,71,'GO:0060205','325/19550',3.08603271737312E-18,1.90730743885768E-16,'71/1365'],
                [0.0322344322344322,'neuron projection terminus',15.315853013085,44,'GO:0044306','141/19550',6.8388708370929E-18,3.35027621273833E-16,'44/1365'],
                [0.0549450549450549,'neuron to neuron synapse',15.315853013085,75,'GO:0098984','361/19550',6.96955270533157E-18,3.35027621273833E-16,'75/1365'],
                [0.0351648351648352,'dendritic spine',13.5603893968741,48,'GO:0043197','183/19550',5.19244957019563E-16,1.90785001604657E-14,'48/1365'],
            ],
            KEGGData: [[0.140661938534279,'Neuroactive ligand-receptor interaction',30.0399400575282,119,'hsa04080','362/8191',2.8065745421198E-33,4.25417614805527E-31,'119/846'],
                        [0.0862884160756501,'Calcium signaling pathway',15.4489447070363,73,'hsa04020','240/8191',2.18877907247077E-18,1.65886413913574E-16,'73/846'],
                        [0.0555555555555556,'Glutamatergic synapse',15.3286616194521,47,'hsa04724','114/8191',4.33088123477341E-18,2.18823472914867E-16,'47/846'],
                        [0.0768321513002364,'Lipid and atherosclerosis',13.6953226720654,65,'hsa05417','215/8191',2.48229823386795E-16,9.40660383360485E-15,'65/846'],
                        [0.0756501182033097,'cAMP signaling pathway',12.5848344493084,64,'hsa04024','221/8191',4.32551957102638E-15,1.21316836373393E-13,'64/846'],
                        [0.049645390070922,'HIF-1 signaling pathway',12.5848344493084,42,'hsa04066','109/8191',4.80212477311347E-15,1.21316836373393E-13,'42/846'],
                        [0.0508274231678487,'Serotonergic synapse',12.4288226103386,43,'hsa04726','115/8191',8.02402122305623E-15,1.73753241521819E-13,'43/846'],
                        [0.0520094562647754,'Dopaminergic synapse',10.7403556665805,44,'hsa04728','132/8191',4.47559684917346E-13,8.48007824053919E-12,'44/846'],
                        [0.0425531914893617,'IL-17 signaling pathway',10.6995827550656,36,'hsa04657','94/8191',5.53065277386932E-13,9.31478361914832E-12,'36/846'],
                        [0.0295508274231678,'Cocaine addiction',10.5726923506464,25,'hsa05030','49/8191',8.9730778476849E-13,1.24756497961882E-11,'25/846'],
                        ]
        }
    },
    components:{
        BubblechartVue
    },
    mounted () {
        this.plotData=this.BPData
        this.getData()
    },
    methods:{
        getData(){
            console.log(this.activePane=="go"?this.activeType:"KEGG")
            var loadingInstance = Loading.service({
                target:document.querySelector('.table')
            });
            this.axios.get(this.GLOBAL.rootAddress+'analysis/enrichment/conventional',{
            params: { 
                'pageNum': this.currentPage,
                'pageSize': this.pageSize,
                'sortBy':this.sortby,
                'desc':this.desc,
                'type':this.activePane=="go"?this.activeType:"KEGG"
            }
            })
            .then(response=> {
                loadingInstance.close();
                this.totalCount=response.data.data.total;               
                this.tableData=response.data.data.records;   
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },
        handleClick(val){
            this.getData() 
            this.currentPage=1
            if(this.activePane=='go')this.yaxis="GO term"
            else this.yaxis="KEGG pathway"
        },
        // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
        },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        rounding(row,column) {
            return row[column.property].toExponential(3)
        },
        selectChanged(){
            if(this.activeType=='Biological Process'){
                this.plotData=this.BPData
            }else if(this.activeType=='Cellular Component'){
                this.plotData=this.CCData
            }else {
                this.plotData=this.MFData
            }
            if (this.$refs.table){
                this.$refs.table.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            this.getData()
        },

    },
}


</script>

<style>

</style>